/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../actions/index';
import {
  Paper,
  TableFooter,
  Title,
  Modal,
  Checkbox,
  Input,
  EmptyView,
  DateRangePicker,
  Table
} from '../../components';
import {
  handleChange,
  handleCheckBox,
  initStock,
  handleClick,
  handleClose,
  handleSubmit,
  onSelectDate
} from './VentesStocks.services';
import { styles } from './VentesStocks.styles';
import { displayPriceFormat } from '../../utils/tools';
import { getInitialDateRange } from '../../utils/suitableDate';
import { STOCK_TABLE_HEAD } from '../../constants/table';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/inventory.svg';
import { EMPTY_DESIGN_STOCK_TEXT, EMPTY_DESIGN_STOCK_TITLE } from '../../constants/dishopInfo';

const INITIAL_STATE = {
  vente: 0,
  name: '',
  stockRestant: 0,
  currentStock: [],
  productId: '',
  sectionId: '',
  checked: false,
  dateRange: getInitialDateRange()
};
class VentesStocks extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  async componentDidMount() {
    await initStock(this.props, this);
  }

  async componentWillReceiveProps(props) {
    const { shopId, menu } = props;
    const { sections = {} } = menu;
    const { shopId: oldShopId, menu: oldMenu } = this.props;
    const { sections: oldSections = {} } = oldMenu;
    if (!_.isEqual(shopId, oldShopId)) {
      await initStock(props, this);
    } else if (!_.isEqual(sections, oldSections)) {
      await initStock(props, this, true);
    }
  }

  createTableRow = data => {
    const { classes } = this.props;
    return (
      <TableBody>
        {data.map((e, i) => {
          return (
            <TableRow
              key={i.toString()}
              style={{ cursor: 'pointer' }}
              onClick={() =>
                handleClick(
                  {
                    name: e.name,
                    vente: e.sold || 0,
                    stockRestant: Number.isInteger(parseInt(e.stock, 10)) ? e.stock : null,
                    productId: e.productId,
                    sectionId: e.sectionId,
                    revenue: e.price || 0
                  },
                  this
                )
              }
            >
              <TableCell align='center' className={classes.tableRow}>
                {e.name}
              </TableCell>
              <TableCell align='center' className={classes.tableRow}>
                {e.sold || 0}
              </TableCell>
              <TableCell align='center' className={classes.tableRow}>
                {displayPriceFormat(e.price || 0)}
              </TableCell>
              <TableCell align='center' className={classes.tableRow}>
                {Number.isInteger(parseInt(e.stock, 10)) ? e.stock : 'non défini'}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  render() {
    const { classes } = this.props;
    const {
      modalOpen,
      stock = {},
      stockRestant,
      checked,
      name,
      vente,
      isLoading,
      revenue,
      dateRange
    } = this.state;

    return (
      <div className='px-4 pb-4'>
        <Title title='Ventes / Stocks' />
        <DateRangePicker
          className='mb-3'
          dateRange={dateRange}
          onSelectDate={dateRange => {
            onSelectDate(this, dateRange);
          }}
          disabled={isLoading}
        />
        {!_.size(stock) > 0 ? (
          <EmptyView
            className={classes.svg}
            src={ImportedSVG}
            isLoading={isLoading}
            title={EMPTY_DESIGN_STOCK_TITLE}
            text={EMPTY_DESIGN_STOCK_TEXT}
          />
        ) : (
          <>
            <Paper scrollOption='auto'>
              <Table
                headCells={STOCK_TABLE_HEAD}
                classes={classes}
                bodyRows={stock}
                createTableRow={(stock) => this.createTableRow(stock)}
                order='desc'
                orderBy='price'
              />
            </Paper>


            <TableFooter lengthOption={_.keys(stock).length} />
            <Modal
              color='secondary'
              title={name}
              header
              size='sm'
              showCancelBtn
              onClick={() => handleSubmit(this)}
              handleClose={() => handleClose(this)}
              isOpen={modalOpen}
            >
              <div>
                <div className='row px-3 '>
                  <div>
                    <div className='mb-2'>
                      <p className={classes.orderDetail}>
                        Nombre de ventes :{' '}
                        <b style={{ fontSize: '18px', margin: '0px 0px 3px 5px' }}>{vente}</b>
                      </p>
                    </div>
                    <div className='mb-2'>
                      <p className={classes.orderDetail}>
                        Chiffre d'affaires:{' '}
                        <b style={{ fontSize: '18px', margin: '0px 0px 3px 5px' }}>
                          {displayPriceFormat(revenue)}{' '}
                        </b>
                      </p>
                    </div>
                  </div>
                  <Input
                    autoFocus
                    margin='dense'
                    id='stockRestant'
                    label='Stock restant'
                    type='number'
                    value={stockRestant}
                    onChange={e => handleChange(e, this)}
                    fullWidth
                  />
                  <Checkbox
                    value={checked}
                    onClick={() => handleCheckBox(this, !checked)}
                    text='Ne pas définir de stock pour ce produit'
                    name='checked'
                  />
                </div>
              </div>
            </Modal>
          </>
        )}
      </div>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime, page }) {
  const { menu = {} } = firebaseRealTime;
  const { shopId } = user;
  return {
    page,
    menu,
    shopId
  };
}

VentesStocks.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(VentesStocks));
